import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import React from 'react';
import './Label.css';
import asButton from '../decorator/asButton';
import withToolTip from '../decorator/withToolTip';
import IconComponent from './Icon';

const Label = React.memo(
  ({ name, toolTip, icon, type, clickId, clickEvent, clickHandler, clickArgs }) => {
    if (isEmpty(name)) {
      return null;
    }
    return (
      <label
        className="label"
        data-label-type={type}
        {...withToolTip(toolTip, 'right')}
        {...asButton(clickId, clickEvent, clickHandler, clickArgs)}>
        {name}
        {icon && <IconComponent src={icon} caption={toolTip} />}
      </label>
    );
  }
);

Label.propTypes = {
  name: PropTypes.string.isRequired,
  toolTip: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.string
};

Label.defaultProps = {
  toolTip: undefined,
  icon: undefined,
  type: 'default'
};

export default Label;
